import component from './showTCaptcha.vue'
export default {
  install(Vue, options) {
    const ComponentBuilder = Vue.extend(component)
    const vm = new ComponentBuilder({
      el: document.createElement('div')
    })

    Vue.prototype.$showTCaptcha = {
      async show(captchaInitOpts = {}, callback) {
        if (vm.isShow) {
          return
        }
        const data = await vm.show(captchaInitOpts)
        return data
      },
      isShow() {
        return vm.isShow
      }
    }
  }
}
